export default "__VITE_ASSET__5xmg8yvx__";